export const SCHEDULE_DEMO_MODAL_CLOSE = 'Payer Onboarding. Calendly. Close'
